// src/components/awoo/awoousuarios/ResumenResenas.js
import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import app from "../../../firebaseConfig";

const ResumenResenas = ({ categoria, producto, onClick }) => {
  const [estadisticas, setEstadisticas] = useState({ promedio: 0, cantidad: 0 });

  useEffect(() => {
    const db = getDatabase(app);
    const refComentarios = ref(db, `nature/Awoo/Categorias/${categoria}/${producto}/Comentarios`);

    const unsubscribe = onValue(refComentarios, (snapshot) => {
      if (snapshot.exists()) {
        const data = Object.values(snapshot.val());
        const total = data.length;
        const suma = data.reduce((acc, cur) => acc + (cur.estrellas || 0), 0);
        const promedio = total > 0 ? suma / total : 0;
        setEstadisticas({ promedio, cantidad: total });
      } else {
        setEstadisticas({ promedio: 0, cantidad: 0 });
      }
    });

    return () => unsubscribe();
  }, [categoria, producto]);

  return (
    <div
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "inline-block",
        backgroundColor: "#f2f2f2",
        padding: "8px 12px",
        borderRadius: "8px",
        color: "#333",
        fontWeight: "bold",
        marginBottom: "10px",
        transition: "background-color 0.2s",
      }}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e0e0e0")}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#f2f2f2")}
    >
      ⭐ {estadisticas.promedio.toFixed(1)} / 5 ({estadisticas.cantidad} reseñas)
    </div>
  );
};

export default ResumenResenas;
